import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { BpmnConnection } from '@shared/interfaces/bpmn';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BpmnConnectionsService } from '../services/bpmn-connections.service';

export const bpmnConnectionResolverFn = (
	route: ActivatedRouteSnapshot
): Observable<BpmnConnection> => {
	const connectionsSvc = inject(BpmnConnectionsService);
	const connectionId = route.paramMap.get('connectionId');

	return !isNaN(connectionId as any)
		? connectionsSvc.find(connectionId).pipe(catchError(() => of(null)))
		: of(null);
};
